const steps = [
  {
    step: "01",
    icon: "ri-calendar-check-line",
    title: "Schedule a Consultation",
    desc: "Complete our inquiry form or reach out directly to schedule an initial consultation. Our team will confirm your appointment and share what to expect from the conversation.",
    detail: "No commitment required. The first conversation is simply about understanding your goals and whether Harambee is the right fit for your journey.",
  },
  {
    step: "02",
    icon: "ri-focus-3-line",
    title: "Clarify Goals & Readiness",
    desc: "In your consultation, we take the time to understand where you are, where you want to go, and what you need to get there. We assess your investor readiness and identify the most relevant advisory pathways.",
    detail: "This is a structured, honest conversation &mdash; not a sales pitch. We will tell you clearly what we can and cannot help with.",
  },
  {
    step: "03",
    icon: "ri-map-2-line",
    title: "Receive Tailored Guidance",
    desc: "Based on your goals and readiness, we provide a clear set of next-step recommendations &mdash; whether that is educational resources, structured advisory sessions, or a pathway toward more advanced services.",
    detail: "Every recommendation is tailored to your specific situation, timeline, and long-term vision for wealth creation.",
  },
];

export default function AdvisoryProcess() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            The Advisory Process
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-5">
            Simple, Clear, and Purposeful
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed">
            Getting started with Harambee advisory is straightforward. Here is how the process works from first contact to tailored guidance.
          </p>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-16 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-[#C9A961]/40 to-transparent" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {steps.map((step, i) => (
              <div key={step.step} className="relative flex flex-col items-center text-center group">
                {/* Step circle */}
                <div className="relative mb-8">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A4D3C] group-hover:bg-[#C9A961] transition-colors duration-300 z-10 relative">
                    <i className={`${step.icon} text-white text-xl`} />
                  </div>
                  <div className="absolute -top-1 -right-1 w-6 h-6 flex items-center justify-center rounded-full bg-[#C9A961] group-hover:bg-[#1A4D3C] transition-colors duration-300">
                    <span className="text-white text-[9px] font-bold">{step.step}</span>
                  </div>
                </div>

                <div className="bg-[#F8F6F3] rounded-lg p-7 border border-[#E8E4DC] group-hover:border-[#C9A961]/40 transition-all duration-300 w-full">
                  <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-3 leading-snug">
                    {step.title}
                  </h3>
                  <p className="text-[#6B6B6B] text-sm leading-relaxed mb-4">{step.desc}</p>
                  <div className="pt-4 border-t border-[#E8E4DC]">
                    <p className="text-[#6B6B6B] text-xs leading-relaxed italic">{step.detail}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="#consult"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#1A4D3C] text-white font-semibold text-sm hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Begin Your Advisory Journey
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
